<template>
  <div>
    <b-table small striped hover selectable
      @row-clicked="rowTurboModeClickHandler"
      :items="turboSettings"
      :fields="fieldsTurboSettings">
    </b-table>

    <modal-ok-cancel @save="saveTurboMode" @cancel="hideTurboMode" size="md"/>

  </div>
</template>

<script>
export default {
  props: {
    currentService: null
  },
  data () {
    return {
      selectedTurboMode: null,
      fieldsTurboSettings: [
        {key: 'incoming_rate', label: this.$i18n.t('Incoming'), sortable: true},
        {key: 'incoming_limit', label: this.$i18n.t('Incoming limit'), sortable: true},
        {key: 'outgoing_rate', label: this.$i18n.t('Outgoing'), sortable: true},
        {key: 'outgoing_limit', label: this.$i18n.t('Outgoing limit'), sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true}
      ]
    }
  },
  methods: {
    hideTurboMode () {
      this.$emit('hideTurboMode')
    },
    rowTurboModeClickHandler (row) {
      if (this.selectedTurboMode) {
        this.selectedTurboMode._rowVariant = ''
      }
      this.selectedTurboMode = row
      this.$set(this.selectedTurboMode, '_rowVariant', 'info')
    },
    saveTurboMode () {
      if (this.selectedTurboMode) {
        let turbo = {
          slink_id: this.currentService.service_link_id,
          turbomode_settings_id: this.selectedTurboMode.settings_id
        }
        let response = this.$store.dispatch('Users/CREATE_UERS_ENABLE_TURBO_MODE', turbo)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$emit('hideTurboMode')
            this.$root.$emit('makeToasts')
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select turbo mode'), 'Error')
      }
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DYNAMIC_SHAPING', this.currentService.service_id)
  },
  computed: {
    turboSettings () {
      let tmp = []
      if (this.$store.getters['Settings/DYNAMIC_SHAPING'].turbo_mode_settings) {
        for (let el of this.$store.getters['Settings/DYNAMIC_SHAPING'].turbo_mode_settings) {
          let newEl = {
            settings_id: el.settings_id,
            incoming_rate: 0,
            incoming_limit: 0,
            outgoing_rate: 0,
            outgoing_limit: 0,
            name: el.name
          }
          if (el.incoming_rate === '-1') {
            newEl.incoming_rate = this.$i18n.t('Unlimited')
          } else if (el.incoming_rate === '0') {
            newEl.incoming_rate = this.$i18n.t('Disabled')
          } else {
            newEl.incoming_rate = el.incoming_rate
          }
          if (el.incoming_limit === 0) {
            newEl.incoming_limit = this.$i18n.t('Not set')
          } else {
            if (el.incoming_limit > 1073741824) {
              newEl.incoming_limit = (el.incoming_limit / 1073741824) + 'G'
            } else if (el.incoming_limit > 1048576) {
              newEl.incoming_limit = (el.incoming_limit / 1048576) + 'M'
            } else if (el.incoming_limit > 1024) {
              newEl.incoming_limit = (el.incoming_limit / 1024) + 'K'
            } else if (el.incoming_limit < 1024) {
              newEl.incoming_limit = el.incoming_limit + 'B'
            }
          }
          if (el.outgoing_rate === '0') {
            newEl.outgoing_rate = this.$i18n.t('Disabled')
          } else {
            newEl.outgoing_rate = el.outgoing_rate
          }
          if (el.outgoing_limit === 0) {
            newEl.outgoing_limit = this.$i18n.t('Not set')
          } else {
            if (el.outgoing_limit > 1073741824) {
              newEl.outgoing_limit = (el.outgoing_limit / 1073741824) + 'G'
            } else if (el.outgoing_limit >= 1048576) {
              newEl.outgoing_limit = (el.outgoing_limit / 1048576) + 'M'
            } else if (el.outgoing_limit >= 1024) {
              newEl.outgoing_limit = (el.outgoing_limit / 1024) + 'K'
            } else if (el.outgoing_limit < 1024) {
              newEl.outgoing_limit = el.outgoing_limit + 'B'
            }
          }
          tmp.push(newEl)
        }
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formTurboMode.vue